module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-christina.399dc5df.jpeg";